import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { PatientMap } from '@/utils/patient-maps'
import { DataPoint } from '@/jsonapi/CommonTypes'

enum ModelTypes {
  SiteStat = 'site-stat',
}

enum ModelTypeNames {
  SiteStat = 'siteStat',
}

/* shouldn't this be programStats? */
export interface SiteStats {
  programName: string
  programInteractions: number
  programAvgAdherencePerc: number
  programPatientsTotal: number
  programPatientsActive: number
  programPatientsCompleted: number
}

export interface SiteUsageConfig {
  monthlyRevenue: number
  monthlyCost: number
  glucometerStripRevenue: number
  // oneTimeGlucometerGatewayCost: number
  // oneTimeVitalsGatewayRevenue: number
  // oneTimeVitalsGatewayCost: number

  gatewaySalePrice: number
  gatewayInstallationFee: number

  vitalsStartDate?: number
  vitalsEndDate?: number
  glucometerStartDate?: number
  glucometerEndDate?: number
}

export interface GlucometerReadingCounts {
  totalCount: number
  qcCount: number
  matchedCount: number
  noPidCount: number
  invalidCount: number
  fixedOidSwapCount: number
  notFixedOidSwapCount: number
}

export interface MonthlySiteRevenueAndCosts {
  siteId: string
  year: number
  month: number
  glucometerStripRevenue?: number
  monthlyEmrCost?: number
  monthlyRevenue?: number
  gatewaySales?: number
  gatewayInstallationFees?: number
}

export interface SiteUsageStats {
  siteId: string
  // glucometerReadings?: number
  glucometerReadingCountsPerMonthByType?: Map<string, GlucometerReadingCounts>
  revenuesAndCosts?: Map<string, MonthlySiteRevenueAndCosts>
  // glucometerReadingsLast5Days?: number // to be removed
  glucometerReadingsRollingAvg?: DataPoint[]

  vitalSignAssignments?: number
  gateways?: number
  residents?: number
  queryStartTimestamp: number
  queryEndTimestamp: number
  resultStartTimestamp: number
  resultEndTimestamp: number
  config: SiteUsageConfig // the computed value, with defaults if none set
  explicitCashflowConfig: SiteUsageConfig // the explicit values, null if not set
  sharedDeviceProgramActive: boolean
}

export interface GatewayStats {
  siteId: string
  vibeId: string
  lastConnectionTimestamp?: number
  lastEthernetDeviceConnectionTimestamp?: number
  uptimeS?: number
  tractorUptimeS?: number
  ferrariUptimeS?: number
  servicesUpToDate?: boolean
}

export interface SharedDeviceStats {
  siteId: string
  serialNumber: string
  type: string
  name: string
  lastConnectionTimestamp?: number
  unitId?: number
  unitIds?: number[]
  unitDesc?: string
}

export interface SiteStatsAttributes {
  resourceId: string
  siteName: string
  org: string
  regionalHealthAuthority: string
  sandbox?: boolean
  siteAvgAdherencePerc: number
  programStatses: SiteStats[]
  siteInteractions: number
  sitePatientsTotal: number
  sitePatientsActive: number
  sitePatientsCompleted: number
  siteEventsUrgent: number
  siteEventsNewChanges: number
  siteUsageStats: SiteUsageStats
  patientMaps: PatientMap[]
  gatewayStats: GatewayStats[]
  sharedDeviceStats: SharedDeviceStats[]
  pids: string[]
}

export interface GetSiteStatsDto {
  startTimestamp: number | undefined
  endTimestamp: number | undefined
}

export interface SiteStatsScheme {
  id: string
  attributes: SiteStatsAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.SiteStat]: {
      keys: {
        remoteId: {},
      },
      attributes: {
        resourceId: { type: 'string' },
        sandbox: { type: 'boolean' },
        siteName: { type: 'string' },
        org: { type: 'string' },
        regionalHealthAuthority: { type: 'string' },
        siteAvgAdherencePerc: { type: 'number' },
        programStatses: { type: 'array' },
        siteInteractions: { type: 'number' },
        sitePatientsTotal: { type: 'number' },
        sitePatientsActive: { type: 'number' },
        sitePatientsCompleted: { type: 'number' },
        siteEventsUrgent: { type: 'number' },
        siteEventsNewChanges: { type: 'number' },
        siteUsageStats: { type: 'object' },
        gatewayStats: { type: 'array' },
        sharedDeviceStats: { type: 'array' },
        pids: { type: 'string' }, // shouldn't it be array?
        patientMaps: { type: 'array' },
        queryStartTimestamp: { type: 'number' },
        queryEndTimestamp: { type: 'number' },
      },
    },
  },
}

export async function getSiteStatsesQuery(params: {
  startTimestamp?: number | undefined
  endTimestamp?: number | undefined
}) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for site stats')
      let query = q.findRecords(ModelTypes.SiteStat)
      if (params && params.startTimestamp != null) {
        query = query.filter(
          { attribute: 'starttimestamp', value: params.startTimestamp },
          { attribute: 'endtimestamp', value: params.endTimestamp }
        )
      }
      return query
    })
    .catch(e => {
      console.log('fetch failed for site stats')
      console.log(e)
    })
}
